import { useSession } from "next-auth/react";
import { useEffect, useRef } from "react";
import { useLoadReportMenu } from "@/stores/reportMenuAtom";

export default function ReportMenuListener() {
    const { status } = useSession();
    const loadReportMenu = useLoadReportMenu();
    const hasFetched = useRef(false);

    useEffect(() => {
        // Only fetch if authenticated and haven't fetched yet in this session lifecycle
        if (status === "authenticated" && !hasFetched.current) {
            loadReportMenu();
            hasFetched.current = true;
        }
    }, [status, loadReportMenu]);

    return null;
}